import styled from '@emotion/styled';
import Icon from 'presentations/views/components/atoms/Icon';
import Headline from 'presentations/views/components/atoms/Headline';
import {
  fontSize,
  fontWeight,
  mediaMaxWithLayoutTheme,
  spacing,
} from 'presentations/views/styles';

import { SyntheticEvent, ReactNode } from 'react';
import { gray05 } from 'presentations/views/styles/color';

interface Props {
  onExpand?: any;
  label?: string;
  name: string;
  helperText?: string;
  content: ReactNode;
  submitField?: ReactNode;
  isOpen: boolean;
}

export default function Component(props: Props) {
  const iconName = props.isOpen ? 'expand_less' : 'expand_more';
  return (
    <ExpandFormField>
      {props.label && (
        <Header
          role="button"
          onClick={(e: SyntheticEvent) => props.onExpand(e, props.name)}
        >
          <Label variant="h2">{props.label}</Label>
          {typeof props.onExpand === 'function' && <Icon name={iconName} />}
        </Header>
      )}
      {props.helperText && <HelperText>{props.helperText}</HelperText>}
      {props.isOpen && (
        <Fields>
          {props.content}
          {props.submitField && <Submit>{props.submitField}</Submit>}
        </Fields>
      )}
    </ExpandFormField>
  );
}

const ExpandFormField = styled.div``;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing(32)} ${spacing(48)};
  cursor: pointer;
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    padding: ${spacing(16)} ${spacing(8)};
  }
`;
const Label = styled(Headline)`
  font-weight: ${fontWeight('bold')};
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    font-size: ${fontSize(14)};
  }
`;
const HelperText = styled.div`
  font-size: ${fontSize(14)};
  padding: 0 ${spacing(48)};
  margin-bottom: ${spacing(16)};
  cursor: pointer;
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    padding: ${spacing(16)} ${spacing(8)};
  }
`;
const Fields = styled.div`
  border-top: 1px solid ${gray05};
  margin-bottom: ${spacing(16)};
  padding: ${spacing(32)} ${spacing(48)};
  ${(props) => mediaMaxWithLayoutTheme(props, 'smartphone')} {
    padding: ${spacing(16)} ${spacing(8)} 0;
    margin-bottom: 0;
  }
`;
const Submit = styled.div`
  margin: ${spacing(16)} 0;
`;
